  <div class="toggle" [id]="id" [class.active]="isActive">
      <div class="toggle-title" (click)="toggleActive($event)">
        <div class="title"><h5 class="title-name">{{question}}</h5></div>
        <div class="icons"><h1><i></i></h1></div> 
     </div>
     <div class="toggle-inner" *ngIf="isActive">
       <ng-content></ng-content>
     </div>
   </div>